import i18n from '@/Config/app/i18n';

// "en" -> "English", localized to the current UI language; falls back to the raw code.
export const languageName = (code: string): string => {
  try {
    return (
      new Intl.DisplayNames([i18n.language || 'en'], { type: 'language' }).of(
        code.replace('_', '-'),
      ) ?? code
    );
  } catch {
    return code;
  }
};
